/**
 * enum status nhận báo cáo cấp dưới
 * ndquang1 05.11.2024
 */
export default {
    NotSubmit: 0, // chưa nộp
    Submited: 1, // đã nộp
    Approved: 2, // đã nhận
    Rejected: 3, // từ chối
    NoCreate: 4, // chưa lập
    Created: 5, // đã lập
    Summarized: 6, // đã tổng hợp
    SummarizedDepartment: 7, // Cục đã tổng hợp
    NotSummarizedDepartment: 8, // Cục chưa tổng hợp
};
